import NextImg from "next/image";
import React, { useState } from "react";
import { AiOutlineMinusCircle, AiOutlinePlusCircle } from "react-icons/ai";
import styled, { css } from "styled-components";
import bigImage from "/public/imagess/bigImage.jpg";
import skillImage from "/public/imagess/skillImage.jpg";

const FlipCard = styled.div`
  position: relative;
  width: 100%;
  height: 500px;
  perspective: 1000px;
`;

const Card = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  transition: transform 1.7s;
  transform-style: preserve-3d;

  ${(props) =>
    props.isFlipped &&
    css`
      transform: rotateY(180deg);
    `}
`;

const Front = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
`;

const Back = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  transform: rotateY(180deg);
`;

const FlipIcon = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 30;

  svg {
    transition: all 0.8s ease-in;
  }
`;

const FlippableSection = () => {
  const [isFlipped, setIsFlipped] = useState(false);

  const handleFlip = () => {
    setIsFlipped((prevState) => !prevState);
  };

  return (
    <FlipCard>
      <Card isFlipped={isFlipped}>
        <Front>
          <figure className="h-full">
            <picture>
              <source srcSet={"/public/imagess/mobile-skillImage.jpg"} media="(max-width: 777px)" />
              <NextImg fill src={skillImage} height={900} alt="skill image" placeholder="blur" className="h-full w-full object-cover" />
            </picture>
          </figure>
        </Front>

        <Back>
          <figure className="h-full">
            <picture>
              <source media="(max-width: 777px)" srcSet="/public/imagess/flippable-sm.jpg" />
              <NextImg fill src={bigImage} height={900} placeholder="blur" className="h-full w-full object-cover" />
            </picture>
          </figure>
        </Back>
      </Card>

      <FlipIcon>
        {isFlipped ? (
          <AiOutlineMinusCircle className="h-8 w-8 cursor-pointer text-white m-3" onClick={handleFlip} />
        ) : (
          <AiOutlinePlusCircle className="h-8 w-8 cursor-pointer" onClick={handleFlip} />
        )}
      </FlipIcon>
    </FlipCard>
  );
};

export default FlippableSection;